import React from 'react'
import { Button, Form, FormGroup } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import FormItem from '../../../common/forms/FormItem'
import DatePicker from '../../../common/forms/input/DatePicker'
import { isRequired, validateEndDate } from '../../../../utils/validators'
import CitySelect from '../../../common/forms/select/CitySelect'
import FormFooter from '../../../common/forms/FormFooter'
import { getMaintenanceStayWithoutArrivalDate } from '../../../../actions/mechanical-maintenance/BusMaintenanceStay'

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString)

const BusMaintenanceStaySearchForm = ({ handleSubmit, dispatchGetMaintenanceStayWithoutArrivalDate, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Ciudad" required>
        <Field
          name="city"
          component={CitySelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="secondary"
      saveButtonDisabled={loading}
    >
      <Button type="button" color="warning" className="mr-2" onClick={dispatchGetMaintenanceStayWithoutArrivalDate} disabled={loading}>
        <i className="fa fa-search mr-2" />
        Buscar sin fecha de llegada
      </Button>
    </FormFooter>
  </Form>
)

BusMaintenanceStaySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatchGetMaintenanceStayWithoutArrivalDate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

BusMaintenanceStaySearchForm.defaultProps = {
  loading: false,
}

const mapDispatchToProps = {
  dispatchGetMaintenanceStayWithoutArrivalDate: getMaintenanceStayWithoutArrivalDate,
}

const form = reduxForm({
  form: 'BusMaintenanceStaySearchForm',
})(BusMaintenanceStaySearchForm)

export default connect(null, mapDispatchToProps)(form)